import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable()
export class RSSFeedService {
    constructor(private http: HttpClient) {}

    getFeedContent(): Observable<any> {
        return this.getRSSFeedXML(environment.clareRSSFeedURL).pipe(
            map(result => {
                const domParser = new DOMParser();
                const els = domParser.parseFromString(result, "application/xml");
                const items = els.getElementsByTagName("item");

                return items[0] ? this.buildFeedItems(items) : [];
            })
        );
    }

    private buildFeedItems(items) {
        const feedItems = [];
        for (const item of items) {
            if (item.getElementsByTagName("link")) {
                feedItems.push({
                    link: item.getElementsByTagName("link")[0].innerHTML,
                    title: item.getElementsByTagName("title")[0].innerHTML,
                    description: item.getElementsByTagName("description")[0].innerHTML,
                    pubDate: item.getElementsByTagName("pubDate")[0].innerHTML,
                });
            }
        }

        return feedItems;
    }

    private getRSSFeedXML(url: string): Observable<string> {
        return this.http
            .get(url, {
                responseType: "text",
            })
            .pipe(
                catchError(error => {
                    console.log("error", error);
                    return throwError(() => error);
                })
            );
    }
}
